import htmlEditButton from 'quill-html-edit-button';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // import the styles
Quill.register('modules/htmlEditButton', htmlEditButton, true);
const allowedTags = [
  'a',
  'br',
  'acronym',
  'b',
  'blockquote',
  'br',
  'code',
  'div',
  'em',
  'i',
  'li',
  'ol',
  'p',
  'span',
  'strong',
  'table',
  'td',
  'tr',
  'ul',
];

function RichTextEditorComponent({value,onChange}) {
  const modules = {
    syntax: true,
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [
          { list: 'ordered' },
          { list: 'bullet' },
        ],
        [{ script: 'sub' }, { script: 'super' }],
        ['clean'],
      ],
    },
    htmlEditButton: {
      
      buttonTitle: 'HTML source', // Text to display as the tooltip for the toolbar button, default: Show HTML source
    },
  };


  return (
    <div style={{ height: '100%' }}>
      <ReactQuill
        value={value}
        theme="snow"
        onChange={onChange}
        style={{ height: '400px' }}
        modules={modules}
      />
    </div>
  );
}
export default RichTextEditorComponent;
